module.exports = __webpack_public_path__ + "static/media/insta-02.9a1f2a77.jpg";